import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Video } from 'lucide-react';
export function DespreFinalCTA() {
  return <section className="py-24 lg:py-32 bg-[#4F2E7E] relative overflow-hidden" data-id="element-1160">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/10 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-1161" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-gold/5 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-1162" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-1163">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-1164">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-xs font-bold uppercase tracking-wider mb-8" data-id="element-1165">
            Sesiunea Cadou
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 text-balance leading-tight" data-id="element-1166">
            Ești pregătit/ă să faci primul pas spre o viață mai abundentă?
          </h2>

          <div className="h-1 w-24 bg-brand-gold rounded-full mx-auto mb-8" data-id="element-1167" />

          <p className="font-subtitle text-lg md:text-xl text-white/85 leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-1168">
            Nu trebuie să ai totul clar ca să începi. Trebuie doar să simți că e
            momentul. Rezervă o sesiune gratuită de evaluare și hai să vedem
            împreună care este următorul pas potrivit pentru tine.
            <br data-id="element-1169" />
            <span className="text-white/70 text-base" data-id="element-1170">
              Online, fără obligații, doar claritate și ghidare.
            </span>
          </p>

          <a href="https://wa.me/40726042604?text=Bun%C4%83.%0A%0ASunt%20interesat%2F%C4%83%20de%20sesiunea%20CADOU%20de%20Claritate%20de%2030%20de%20minute.%0A%0AVreau%20s%C4%83%20aflu%20mai%20multe%20detalii%20despre%20programele%20tale.%0A%0AMul%C8%9Bumesc." target="_top" className="group inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-text font-heading font-bold text-lg md:text-xl px-8 md:px-10 py-5 md:py-6 rounded-2xl hover:bg-white transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1" data-id="element-1171">
            Rezervă Sesiunea Gratuită de Evaluare
            <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-1172" />
          </a>

          <div className="mt-8 flex items-center justify-center gap-2 text-white/70 text-sm" data-id="element-1173">
            <Video className="w-4 h-4" data-id="element-1174" />
            Sesiunea se desfășoară online, pe Zoom
          </div>
        </motion.div>
      </div>
    </section>;
}